import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var _context5, _context6; var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _forEachInstanceProperty(_context5 = ownKeys(Object(source), !0)).call(_context5, function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : _forEachInstanceProperty(_context6 = ownKeys(Object(source))).call(_context6, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import actions from '../actions/alertsSettingActions';
import { createAlertSubscriptions, deleteAlertSubscriptions, fetchAlertsType, getAdminList, getAlertSubscriptions, updateAlertSubscriptions } from '../apis';
export var fetchAlertsTypeOptionsAction = function fetchAlertsTypeOptionsAction() {
  return {
    type: actions.fetchAlertsTypeOptions,
    payload: {
      isLoading: true
    }
  };
};
export var fetchAlertsTypeOptions = function fetchAlertsTypeOptions(_ref) {
  var apipathprefix = _ref.apipathprefix,
      accessTokenApiPath = _ref.accessTokenApiPath,
      apiBaseUrl = _ref.apiBaseUrl;
  return function (dispatch) {
    dispatch(fetchAlertsTypeOptionsAction());
    return fetchAlertsType(_defineProperty({
      apiBaseUrl: apiBaseUrl,
      pathprefix: apipathprefix,
      accessTokenApiPath: accessTokenApiPath
    }, "apiBaseUrl", apiBaseUrl)).then(function (response) {
      var _context;

      var alertTypes = response.alertTypes;

      var alertTypesOptions = _mapInstanceProperty(_context = alertTypes || []).call(_context, function (type) {
        return {
          value: type.name,
          label: type.name
        };
      });

      dispatch(fetchingAlertsTypeOptionsSucceeded(alertTypesOptions));
    })["catch"](function (ex) {
      dispatch(fetchingAlertsTypeOptionsFailed());
    });
  };
};
export var fetchingAlertsTypeOptionsSucceeded = function fetchingAlertsTypeOptionsSucceeded(alertTypesOptions) {
  return {
    type: actions.fetchingAlertsTypeOptionsSucceeded,
    payload: {
      isLoading: false,
      alertTypesOptions: alertTypesOptions
    }
  };
};
export var fetchingAlertsTypeOptionsFailed = function fetchingAlertsTypeOptionsFailed() {
  return {
    type: actions.fetchingAlertsTypeOptionsFailed,
    payload: {
      isLoading: false
    }
  };
};
export var fetchAlertSchemasAction = function fetchAlertSchemasAction() {
  return {
    type: actions.fetchAlertSchemas,
    payload: {
      isLoading: true
    }
  };
};
export var fetchAlertSchemas = function fetchAlertSchemas(_ref2) {
  var apipathprefix = _ref2.apipathprefix,
      accessTokenApiPath = _ref2.accessTokenApiPath,
      apiBaseUrl = _ref2.apiBaseUrl;
  return function (dispatch) {
    dispatch(fetchAlertSchemasAction());
    return _Promise.all([fetchAlertsType({
      pathprefix: apipathprefix,
      accessTokenApiPath: accessTokenApiPath,
      apiBaseUrl: apiBaseUrl
    }), getAlertSubscriptions({
      pathprefix: apipathprefix,
      accessTokenApiPath: accessTokenApiPath,
      apiBaseUrl: apiBaseUrl
    })]).then(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          alertTypeResponse = _ref4[0],
          alertSubscriptionsResponse = _ref4[1];

      var alertTypes = alertTypeResponse.alertTypes;
      var subscriptions = alertSubscriptionsResponse.subscriptions;

      var alertSchemas = _mapInstanceProperty(alertTypes).call(alertTypes, function (alertType) {
        var _context2;

        return _objectSpread(_objectSpread({}, alertType), {}, {
          subscription: _findInstanceProperty(_context2 = subscriptions || []).call(_context2, function (subscription) {
            return subscription.alertTypeID === alertType.id;
          })
        });
      });

      dispatch(fetchAlertSchemasSucceeded(alertSchemas));
    })["catch"](function (ex) {
      dispatch(fetchAlertSchemasFailed());
    });
  };
};
export var fetchAlertSchemasSucceeded = function fetchAlertSchemasSucceeded(alertSchemas) {
  return {
    type: actions.fetchAlertSchemasSucceeded,
    payload: {
      isLoading: false,
      alertSchemas: alertSchemas
    }
  };
};
export var fetchAlertSchemasFailed = function fetchAlertSchemasFailed() {
  return {
    type: actions.fetchAlertSchemasFailed,
    payload: {
      isLoading: false
    }
  };
};
export var createAlertSubscriptionAction = function createAlertSubscriptionAction(subscription) {
  return {
    type: actions.createAlertSubscription,
    requestPayload: subscription,
    payload: {
      isLoading: true
    }
  };
};
export var createAlertSubscription = function createAlertSubscription(_ref5) {
  var subscription = _ref5.subscription,
      apipathprefix = _ref5.apipathprefix,
      accessTokenApiPath = _ref5.accessTokenApiPath,
      apiBaseUrl = _ref5.apiBaseUrl;
  return function (dispatch) {
    dispatch(createAlertSubscriptionAction(subscription));
    return createAlertSubscriptions({
      accessTokenApiPath: accessTokenApiPath,
      pathprefix: apipathprefix,
      apiBaseUrl: apiBaseUrl,
      payload: subscription
    }).then(function (response) {
      dispatch(alertSubscriptionSucceeded());
      dispatch(fetchAlertSchemas({
        accessTokenApiPath: accessTokenApiPath,
        apipathprefix: apipathprefix,
        apiBaseUrl: apiBaseUrl
      }));
    })["catch"](function (ex) {
      dispatch(alertSubscriptionFailed());
    });
  };
};
export var updateAlertSubscriptionAction = function updateAlertSubscriptionAction(subscription) {
  return {
    type: actions.updateAlertSubscription,
    requestPayload: subscription,
    payload: {
      isLoading: true
    }
  };
};
export var updateAlertSubscription = function updateAlertSubscription(_ref6) {
  var subscription = _ref6.subscription,
      apiBaseUrl = _ref6.apiBaseUrl,
      apipathprefix = _ref6.apipathprefix,
      accessTokenApiPath = _ref6.accessTokenApiPath;
  return function (dispatch) {
    dispatch(updateAlertSubscriptionAction(subscription));
    return updateAlertSubscriptions({
      pathprefix: apipathprefix,
      payload: subscription,
      accessTokenApiPath: accessTokenApiPath,
      apiBaseUrl: apiBaseUrl
    }).then(function (response) {
      dispatch(alertSubscriptionSucceeded());
      dispatch(fetchAlertSchemas({
        accessTokenApiPath: accessTokenApiPath,
        apipathprefix: apipathprefix,
        apiBaseUrl: apiBaseUrl
      }));
    })["catch"](function (ex) {
      dispatch(alertSubscriptionFailed());
    });
  };
};
export var deleteAlertSubscriptionAction = function deleteAlertSubscriptionAction(subscription) {
  return {
    type: actions.deleteAlertSubscription,
    requestPayload: subscription,
    payload: {
      isLoading: true
    }
  };
};
export var deleteAlertSubscription = function deleteAlertSubscription(_ref7) {
  var subscription = _ref7.subscription,
      apipathprefix = _ref7.apipathprefix,
      accessTokenApiPath = _ref7.accessTokenApiPath;
  return function (dispatch) {
    dispatch(deleteAlertSubscriptionAction(subscription));
    return deleteAlertSubscriptions({
      apiBaseUrl: apiBaseUrl,
      pathprefix: apipathprefix,
      payload: subscription
    }).then(function (response) {
      dispatch(alertSubscriptionSucceeded());
      dispatch(fetchAlertSchemas({
        apipathprefix: apipathprefix,
        accessTokenApiPath: accessTokenApiPath
      }));
    })["catch"](function (ex) {
      dispatch(alertSubscriptionFailed());
    });
  };
};
export var alertSubscriptionSucceeded = function alertSubscriptionSucceeded() {
  return {
    type: actions.alertSubscriptionSucceeded,
    payload: {
      isLoading: false,
      isModalOpen: false
    }
  };
};
export var alertSubscriptionFailed = function alertSubscriptionFailed() {
  return {
    type: actions.alertSubscriptionFailed,
    payload: {
      isLoading: false
    }
  };
};
export var toggleModalState = function toggleModalState(isModalOpen) {
  return {
    type: actions.toggleModalState,
    payload: {
      isModalOpen: isModalOpen
    }
  };
};
export var fetchAdminListAction = function fetchAdminListAction() {
  return {
    type: actions.fetchAdminList,
    payload: {
      fetchingAdmins: true
    }
  };
};
export var fetchAdminList = function fetchAdminList(_ref8) {
  var apiBaseUrl = _ref8.apiBaseUrl,
      apipathprefix = _ref8.apipathprefix,
      accessTokenApiPath = _ref8.accessTokenApiPath,
      allowedAdminRoles = _ref8.allowedAdminRoles;
  return function (dispatch) {
    dispatch(fetchAdminListAction());
    return getAdminList({
      apiBaseUrl: apiBaseUrl,
      pathprefix: apipathprefix,
      accessTokenApiPath: accessTokenApiPath
    }).then(function (response) {
      var _context3, _context4;

      var admins = response.admins;

      var druvaCloudAdmins = _filterInstanceProperty(_context3 = admins || []).call(_context3, function (admin) {
        return _includesInstanceProperty(allowedAdminRoles).call(allowedAdminRoles, admin.role);
      });

      var adminList = _mapInstanceProperty(_context4 = druvaCloudAdmins || []).call(_context4, function (admin) {
        return {
          label: admin.email,
          value: admin.email,
          subscriberID: admin.globalAdminId,
          subscriberEmail: admin.email
        };
      });

      dispatch(fetchAdminListSucceeded(adminList));
    })["catch"](function (ex) {
      dispatch(fetchAdminListFailed());
    });
  };
};
export var fetchAdminListSucceeded = function fetchAdminListSucceeded(adminList) {
  return {
    type: actions.fetchAdminListSucceeded,
    payload: {
      fetchingAdmins: false,
      adminList: adminList
    }
  };
};
export var fetchAdminListFailed = function fetchAdminListFailed() {
  return {
    type: actions.fetchAdminListFailed,
    payload: {
      fetchingAdmins: false
    }
  };
};